export default __webpack_public_path__ + "static/media/59.4aa42cd9.jpg";